import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Card, Table, Button, Checkbox, TableRow, TableBody, TableCell, Container, TableContainer, TablePagination
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import Iconify from "../../components/Iconify";
import { UserListHead } from "../../sections/@dashboard/user";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import { GetActiveMatchListAction, PublichActiveMatchStatusAction } from "../../redux/actions/MatchAction";
import Loader from "src/components/Loader";

export default function ActiveMatchList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const poolPublishSelector = useSelector(state => state.matches.match_publish)
    const loadingSelector = useSelector(state => state.matches.loading)
    const [publichClick, setPublichClick] = useState(false);
    const [clickStatus, setClickStatus] = useState(false)
    const ContestListData = useSelector((state) => state.matches.active_match_list.data);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [state, setState] = useState({
        ContestListData: [],
        totalCountContestList: 0,
        logoImg: [],
        title: "",
        subtitle: "",
        dis_val: "",
    });

    useEffect(() => {
        if (ContestListData !== undefined) {
            setState({
                ...state,
                ContestListData: ContestListData?.data?.match_list,
                totalCountContestList: ContestListData?.data?.total_count,
            });
        }
    }, [ContestListData]);

    useEffect(() => {
        dispatch(GetActiveMatchListAction(page, rowsPerPage));
        setClickStatus(false)
    }, [dispatch, page, rowsPerPage]);

    useEffect(() => {
        if (Object.keys(poolPublishSelector).length > 0 && publichClick) {
            if (poolPublishSelector.status) {
                setTimeout(() => {
                    dispatch(GetActiveMatchListAction(page, rowsPerPage))
                }, 500);
            }
            setClickStatus(false)
            setPublichClick(false)
        }
    }, [poolPublishSelector, page, rowsPerPage, publichClick])

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const ViewPools = (contest_id, name) => {
        navigate(`/dashboard/activepoollistmatch/${contest_id}`, { state: { type: "m", gtype: "ckt", name: name } }, { replace: true });
    };

    return (
        <Page title="Active Matches">
            {clickStatus || loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Active Matches"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Active Matches" },
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: "c_title", label: "Title", },
                                        { id: "c_subtitle", label: "Subtitle", alignRight: false },
                                        { id: "c_date", label: "Date & Time", alignRight: false },
                                        { id: "c_pool", label: "Pool Contest", alignRight: false },
                                        { id: "c_publish", label: "Publish", alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {state?.ContestListData?.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row">{page * rowsPerPage + (index + 1)}.</TableCell>
                                            <TableCell>{data.title}</TableCell>
                                            <TableCell> {data.subtitle} </TableCell>
                                            <TableCell> {data.date_start_ist ? new Date(data.date_start_ist).toUTCString().split("GMT")[0] : "-"}</TableCell>
                                            <TableCell>
                                                <Button onClick={() => ViewPools(data.match_id, data.title)}>
                                                    <Iconify icon="eva:eye-fill" width={24} height={24} />
                                                </Button>
                                            </TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={data.is_publish === 1 ? true : false}
                                                    onChange={({ target }) => {
                                                        {
                                                            dispatch(
                                                                PublichActiveMatchStatusAction({
                                                                    match_id: data.match_id,
                                                                    is_publish: data.is_publish == 1 ? 0 : 1,
                                                                })
                                                            );
                                                            setPublichClick(true)
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state ? state.totalCountContestList : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}